import { getFieldDiff } from "games/utils";

/*
 * @param {object} play - the most up to date version of the play
 * @param {object} earlierPlay - the same play from 1 state earlier, before the most recent form input
 */
const getPointsDiff = (play, earlierPlay) => {
  const homePointsDiff = getFieldDiff(play, earlierPlay, "homePointsGained");
  const awayPointsDiff = getFieldDiff(play, earlierPlay, "awayPointsGained");
  return {
    home: homePointsDiff,
    away: awayPointsDiff
  };
};

export { getPointsDiff };
